export { PRO_THEME, STATUS_ICON } from '../_common/js/progress/const';

export const CIRCLE_SIZE_PX = 112;

// 进度大于 10 ，进度百分比显示在内部；进度百分比小于 10 进度显示在外部
export const PLUMP_SEPARATE = 10;
